// extracted by mini-css-extract-plugin
export default {"mainMenuContent":"MainMenuContent_mainMenuContent__1o2ZU","tabElements":"MainMenuContent_tabElements__JPfvM"};